export const enum EventListeners {
	OPEN_CHATBOT = 'openChatbot',
	CHATBOT_CLOSED = 'chatbotClosed',
	SCRIPT_LOADED = 'load',
	SCRIPT_ERROR = 'error',
}
